'use client';

import { Box, Image, Text } from '@doist/marketist';
import css from './stats-box.module.css';
type StatsBoxType = {
  src: string;
  width: number;
  height: number;
  title: string;
  desc: string;
};
function StatsBox({
  title,
  desc,
  ...rest
}: StatsBoxType) {
  return <Box className={css.statsBox} data-sentry-element="Box" data-sentry-component="StatsBox" data-sentry-source-file="stats-box.tsx">
            <Box className={css.statsBoxImgContainer} data-sentry-element="Box" data-sentry-source-file="stats-box.tsx">
                <Image {...rest} alt="" data-sentry-element="Image" data-sentry-source-file="stats-box.tsx" />
            </Box>
            <Box className={css.statsBoxTextContainer} data-sentry-element="Box" data-sentry-source-file="stats-box.tsx">
                <Text size="major-sm" data-sentry-element="Text" data-sentry-source-file="stats-box.tsx">{title}</Text>
                <Text weight="medium" size="body-base" data-sentry-element="Text" data-sentry-source-file="stats-box.tsx">
                    {desc}
                </Text>
            </Box>
        </Box>;
}
export { StatsBox };